import React from "react";
import {
    Heading,
    RadioGroupField,
    Radio,
    Card,
    Flex,
    Text
} from "@aws-amplify/ui-react";

const renderMultilineText = (text) =>
    text.split('\n').map((line, idx) => (
        <span key={idx}>
            {line}
            <br />
        </span>
    ));

const QuestionTemplate = ({ heading, question, options, value, onChange, disabled }) => (
    <Card
        width="100%"
        maxWidth="800px"
        padding="2rem"
        variation="outlined"
        borderRadius="medium"
        boxShadow="2px 2px 3px 4px var(--amplify-colors-neutral-60)"
    >
        <Heading style={{
            color: '#88a6c7',
            fontSize: '2rem',
            fontWeight: 500
        }} marginBottom="1.5rem">{heading}</Heading>
        <Heading style={{
            color: '#2a2f2e',
            fontSize: '1.3rem',
            fontWeight: 500
        }}>{renderMultilineText(question)}</Heading>

        <RadioGroupField
            label=""
            value={value}
            isDisabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            style={{ margin: "1rem" }}
        >
            {options.map((opt, idx) => (
                <Flex key={idx} alignItems="flex-start" gap="0.75rem" paddingBottom="1rem">
                    <Radio value={opt.id} />
                    <Text style={{ lineHeight: "1" }}>{renderMultilineText(opt.label)}</Text>
                </Flex>
            ))}
        </RadioGroupField>
    </Card>
);

export default QuestionTemplate;
